import { Button, Row, Typography, useControlled, useTheme } from "@commonlibs";
import clsx from "clsx";
import useTranslate from "ui/locale/hooks/useTranslate";
import UploadInput from "../UploadInput/UploadInput";
import { DocumentUploadProps } from "./DocumentUpload.types";

function DocumentUpload({ className, value, onChange, defaultValue, fileTypes = "application/pdf", ...rest }: DocumentUploadProps) {
    const [file, setFile] = useControlled<File | undefined>(defaultValue, value, onChange);
    const translate = useTranslate();
    const { spacing } = useTheme();

    function handleOnChange(file: File | FileList | undefined) {
        if (file instanceof File || file === undefined) {
            setFile(file);
        }
    }

    return (
        <UploadInput className={clsx(className, "document-upload")} onChange={handleOnChange} value={file} fileTypes={fileTypes} {...rest}>
            {({ isLoading }) => (
                <Row alignItems="center" gap={spacing["2"]}>
                    <Button variant="outlined" loading={isLoading} disabled={isLoading}>
                        {translate(file ? "changeFile" : "uploadFile")}
                    </Button>
                    <Typography variant="body2Strong" css={{ flex: 1 }} numberOfLines={1}>
                        {file?.name ?? translate("noFileSelected")}
                    </Typography>
                </Row>
            )}
        </UploadInput>
    );
}

export default DocumentUpload;
